// extracted by mini-css-extract-plugin
export default {"resultsContainer":"results_resultsContainer__09xXm","input-details":"results_input-details__u67sM","calculationResults":"results_calculationResults__TJ2dp"};